import { isDocuSignEnabled } from '@/feature/docusign.feature';
import {
    selectAssetCreationDate,
    selectAssetStatus,
    selectOrderType,
} from '@repo/api-adapters/selectors/customer-assets.selectors';
import { useSignRequests } from '@repo/hooks';
import type { SignRequestRow } from '@repo/types/docusign';

import { getServiceBaseUrl } from '@/api/helpers.api';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { getDocusignFromDateValue, toStatusViewRow } from '@/utils/docusign.utils';
import { getAppConfig } from '@/utils/window.utils';

export const useFetchSignatureStatus = (enabled = true) => {
    const basePath = getServiceBaseUrl(getAppConfig().api.services.orderTaking, 'docusign');
    const { assetId, assetType } = useAssetParams();
    const { data: assetData, isLoading: isAssetLoading } = useAsset(assetType, assetId);
    const creationDate = selectAssetCreationDate(assetData);

    const {
        data: signRequests = [],
        isFetching,
        isError: hasError,
        refetch,
    } = useSignRequests({
        orderId: assetId,
        fromDate: getDocusignFromDateValue(creationDate),
        enabled:
            enabled &&
            Boolean(creationDate) &&
            isDocuSignEnabled({
                assetType,
                orderType: selectOrderType(assetData),
                assetStatus: selectAssetStatus(assetData),
            }),
        basePath,
    });

    const statusRows: SignRequestRow[] = signRequests.map(toStatusViewRow);

    const showLoading = (isAssetLoading || isFetching) && statusRows.length === 0;
    const isEmpty = !showLoading && !isFetching && !hasError && statusRows.length === 0;

    return { statusRows, showLoading, isEmpty, hasError, isFetching, refetch };
};
